import { Service, service, inject } from './di'
import { StorageService } from './StorageService'
import { EventService } from './EventService'
import { ConfigService } from './ConfigService'

const THRESHOLD = 4

const flyersViewsName = 'flyers-views-count'
const whenWasHiddenName = 'when-was-hidden-mobile-popup-banner'

@service
export class FlyersViewedService extends Service {
    @inject storageService: StorageService
    @inject eventService: EventService
    @inject config: ConfigService

    getViews() {
        return Number(Cookies.get(flyersViewsName)) || 0
    }

    setViews(number: number) {
        Cookies.set(flyersViewsName, number.toString(), {
            expires: 1,
            domain: this.config.getCookiesDomain(),
        })
    }

    count() {
        const views = this.getViews() + 1
        this.setViews(views)
        if (!this.isBannerHidden()) {
            this.eventService.displayMobilePopupBanner()
        }
    }

    isLimitReached = () => Number(this.getViews()) / THRESHOLD >= 1

    isBannerHidden() {
        const whenWasHidden = Cookies.get(whenWasHiddenName)
        if (!this.isLimitReached()) {
            return true
        }

        if (whenWasHidden === null) {
            return false
        }

        return Math.abs(new Date().getTime() - parseInt(whenWasHidden)) <= 864e5
    }

    hide() {
        Cookies.set(whenWasHiddenName, new Date().getTime().toString(), {
            expires: 1,
            domain: this.config.getCookiesDomain(),
        })
    }
}
